import { useRouter } from "next/router";

interface LanguageSwitchProps {
  type?: "big" | "small";
}

function pathWithoutLocale(asPath: string) {
  const match = asPath.match(/^\/(en|de)(?=\/|$|\?|#)/);
  if (!match) return asPath || "/";
  const rest = asPath.slice(match[0].length);
  return rest || "/";
}

function hrefForLocale(asPath: string, locale: "en" | "de") {
  const path = pathWithoutLocale(asPath);
  if (locale === "de") return path;
  return path === "/" ? "/en" : `/en${path}`;
}

export function LanguageSwitch({ type = "big" }: LanguageSwitchProps) {
  const { asPath, locale } = useRouter();
  const nextLocale = locale === "en" ? "de" : "en";
  // News posts are loaded in getServerSideProps. next/link only flips the
  // client locale, so the previous language's posts stay on screen until a
  // full document load requests the other locale.
  const href = hrefForLocale(asPath, nextLocale);

  return (
    <a href={href} className="flex gap-2">
      <div className={`${locale === "de" ? "underline" : ""}`}>
        {type === "big" ? "Deutsch" : "DE"}
      </div>
      <div>/</div>
      <div className={`${locale === "en" ? "underline" : ""}`}>
        {type === "big" ? "English" : "EN"}
      </div>
    </a>
  );
}
